/**
 * Returns a string representation of the status based on the given status code.
 * @param {number | undefined} status The status code.
 * @returns {string} The corresponding status description.
 */
export default function Status(status: number | undefined) {
  switch (status) {
    case 0:
      return "Pending";
    case 1:
      return "Active";
    case 2:
      return "Deactivated";
    case 3:
      return "Application";
    default:
      return "";
  }
}
